// src/pages/SplashPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SplashPage = () => {
  const navigate = useNavigate();
  const hasTown = localStorage.getItem('gather-town-id');

  useEffect(() => {
    if (hasTown) navigate('/');
  }, [hasTown, navigate]);

  return (
    <div style={s.page}>
      <div style={s.inner}>
        <div style={s.logoMark}>
          <div style={s.circle} />
          <span style={s.word}>Gather</span>
        </div>
        <div style={s.tag}>Everything happening locally,<br />in one clear place</div>
        <button style={s.btn} onClick={() => navigate('/county')}>Get started</button>
      </div>
    </div>
  );
};

const s = {
  page: { minHeight: '100vh', background: 'var(--sage)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  inner: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, animation: 'fadeUp 0.8s ease forwards' },
  logoMark: { width: 180, height: 180, background: 'var(--sage)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', marginBottom: 8 },
  circle: { position: 'absolute', inset: 8, borderRadius: '50%', border: '1.5px solid rgba(255,255,255,0.35)' },
  word: { fontFamily: 'Nunito, sans-serif', fontSize: 36, fontWeight: 400, color: 'var(--sage-dark)' },
  tag: { fontSize: 14, color: 'var(--sage-dark)', fontWeight: 600, opacity: 0.75, textAlign: 'center', padding: '0 40px', lineHeight: 1.6 },
  btn: { marginTop: 28, background: 'var(--sage-dark)', color: 'white', border: 'none', padding: '16px 52px', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
};

export default SplashPage;
